import React, { memo, useEffect, useMemo } from 'react';
import { useObservable } from 'react-use-observable';

import { financialStatementFutureService } from 'v2/services/financialStatement/future';
import type { ListOrder } from 'v2/services/financialStatement/statement';

import ContentTable from '../ContentTable';

type Props = {
  order: ListOrder;
  shouldDisableSortBtn: (...args: any[]) => any;
};

function Future({ order, shouldDisableSortBtn }: Props) {
  useObservable(() => financialStatementFutureService.loadData(order), [order]);

  const [entries] = useObservable(() => financialStatementFutureService.getFinancialStatementFuture(), [], []);
  const [pagination] = useObservable(() => financialStatementFutureService.getPaginationResponse(), []);
  const [isLoading] = useObservable(() => financialStatementFutureService.isLoading(), []);

  const handlePagination = useMemo(
    () => ({
      onChangeRowsPerPage: (perPage: number) => {
        financialStatementFutureService.setPagination({
          ...pagination,
          ...{ per_page: perPage, current_page: 1, order }
        });
        document.getElementById('future_table').scrollIntoView();
      },
      onChangePage: (page: number) => {
        financialStatementFutureService.setPagination({ ...pagination, ...{ current_page: page, order } });
        document.getElementById('future_table').scrollIntoView();
      }
    }),
    [pagination, order]
  );

  useEffect(() => {
    if (!entries) return;
    shouldDisableSortBtn?.(!entries?.length);
  }, [entries, shouldDisableSortBtn]);

  return (
    <ContentTable
      id='future_table'
      balanceLabel='Créditos previstos'
      data={entries}
      pagination={pagination}
      handlePagination={handlePagination}
      loading={isLoading}
    />
  );
}

export default memo(Future);
